import type { FC } from 'react';

import BareMetalClusters, { type BareMetalClustersProps } from './Caas/BareMetalClusters';
import OpenstackClusters, { type OpenstackClustersProps } from './Caas/OpenstackClusters';
import CloudReport, { type CloudReportProps } from './CloudReport';
import OsProjects, { type OsProjectsProps } from './Compute/OsProjects';
import Users, { type UsersProps } from './Users';

// Discriminated union types
interface OsProjectsTabConfig {
  name: string;
  text: string;
  Component: FC<OsProjectsProps>;
}

interface OpenstackClustersTabConfig {
  name: string;
  text: string;
  Component: FC<OpenstackClustersProps>;
}

interface BareMetalClustersTabConfig {
  name: string;
  text: string;
  Component: FC<BareMetalClustersProps>;
}

interface UsersTabConfig {
  name: string;
  text: string;
  Component: FC<UsersProps>;
}

interface CloudReportTabConfig {
  name: string;
  text: string;
  Component: FC<CloudReportProps>;
}

type TabConfig = OsProjectsTabConfig | UsersTabConfig | OpenstackClustersTabConfig | BareMetalClustersTabConfig | CloudReportTabConfig;

interface ProductDetailsContentMap {
  compute: TabConfig[];
  evaluation: TabConfig[];
  caasonopenstack: TabConfig[];
  caasonbaremetal: TabConfig[];
  baremetal: TabConfig[];
}


// Component wrappers with inferred types
const OsProjectsWrapper: FC<OsProjectsProps> = (props) => <OsProjects {...props} />;
const OpenstackClustersWrapper: FC<OpenstackClustersProps> = (props) => <OpenstackClusters {...props} />;
const BareMetalClustersWrapper: FC<BareMetalClustersProps> = (props) => <BareMetalClusters {...props} />;
const UsersWrapper: FC<UsersProps> = (props) => <Users {...props} />;
const CloudReportWrapper: FC<CloudReportProps> = (props) => <CloudReport {...props} />;


const ProductDetailsContent: ProductDetailsContentMap = {
  compute: [
    { name: 'osprojects', text: 'OS Projects', Component: OsProjectsWrapper },
    { name: 'users', text: 'Users', Component: UsersWrapper },
    { name: 'cloudreport', text: 'Cloud Report', Component: CloudReportWrapper },
  ],
  evaluation: [
    { name: 'osprojects', text: 'OS Projects', Component: OsProjectsWrapper },
    { name: 'users', text: 'Users', Component: UsersWrapper },
    { name: 'cloudreport', text: 'Cloud Report', Component: CloudReportWrapper },
  ],
  caasonopenstack: [
    { name: 'clusters', text: 'Clusters', Component: OpenstackClustersWrapper },
    { name: 'users', text: 'Users', Component: UsersWrapper },
    { name: 'cloudreport', text: 'Cloud Report', Component: CloudReportWrapper },
  ],
  caasonbaremetal: [
    { name: 'clusters', text: 'Clusters', Component: BareMetalClustersWrapper },
    { name: 'users', text: 'Users', Component: UsersWrapper },
  ],
  baremetal: [{ name: 'users', text: 'Users', Component: UsersWrapper }],
};

export default ProductDetailsContent;
